/**
 * Created by tofael on 8/9/17.
 */

import React from 'react';
import moment from 'moment';
import Subheader from 'material-ui/Subheader';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import RaisedButton from 'material-ui/RaisedButton';
import AddIcon from 'material-ui/svg-icons/content/add';
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import IconButton from 'material-ui/IconButton';
import {List, ListItem} from 'material-ui/List';
import {typography} from 'material-ui/styles';

import utils from '../../../utility/utils';
import globalStyles from '../../../utility/styles';

const style = {
  box: {
    backgroundColor: '#fff',
    overflow: 'hidden',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
  },
  select: {
    width: '100%'
  },
  content: {
    paddingLeft: 10,
    paddingRight: 10
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  add: {
    float: 'right',
    paddingRight: 10,
    cursor: 'pointer'
  },
  noDataText: {
    textAlign: 'center',
    fontSize: 16,
    margin: 20,
    fontWeight: typography.fontWeightLight
  }
};


const getWeekArray = () => {
  let days = [];
  for (let i = 0; i < 7; i++) {
    days.push(moment().add(i, 'day'))
  }
  return days;
};

const weekArray = getWeekArray();

const renderForm = (operatingHours, onChange, start_time, end_time , submitSchedule) => {

  const disableEndTimeOption =(endTimeOption)=>{
    return endTimeOption <= operatingHours[start_time];
  }

  const disableStartTimeOption =(startTimeOption)=>{
    return operatingHours[end_time] <= startTimeOption;
  }

  return (
      <div>
          <SelectField
              floatingLabelText="From"
              autoWidth={true}
              onChange={onChange.bind(null, 'start_time')}
              value={start_time}
              style={style.select}>
            {
              operatingHours.map((hour, index) => (
                <MenuItem
                    key={index}
                    value={index}
                    primaryText={ utils.toAppTime(hour) }
                    disableStartTimeOption={disableStartTimeOption(hour)}
                />
             ))
            }
          </SelectField>

          <SelectField
              floatingLabelText="To"
              autoWidth={true}
              style={style.select}
              value={end_time}
              onChange={onChange.bind(null, 'end_time')}>
            {
              operatingHours.map((hour, index) => (
                    <MenuItem
                        disabled={disableEndTimeOption(hour)}
                        key={index}
                        value={index}
                        primaryText={ utils.toAppTime(hour) }
                    />
                ))
            }
          </SelectField>
        <br/>
          <RaisedButton fullWidth={true} onTouchTap={submitSchedule} label="Add"/>
      </div>
  )
}

const renderSchedulesByDay= (schedules, day, showAlert)=>{
  let currentDaySchedules = schedules.filter((_s)=>(moment(_s.start_time).isSame(day,'day')));
  return <List>
    {
      currentDaySchedules.length >0 && currentDaySchedules.map((schedule, index) => {
          return (
              <ListItem
                key={index}
                rightIcon={< DeleteIcon onTouchTap={showAlert.bind(null,'Are you sure you want to delete schedule?','delete-schedule',{scheduleId: schedule.id})}/>}
                primaryText={` ${ utils.toAppTime(schedule.start_time)} to ${utils.toAppTime(schedule.end_time)}`}
              />
          )
        }
      )
    }
    {
      currentDaySchedules.length === 0 && <div style={style.noDataText}> No schedules.</div>
    }
  </List>;
}

const DoctorSchedule = ({ setScheduleFormDate, scheduleDate, start_time, end_time, onChange, operatingHours, schedules,
  submitSchedule, showAlert}) => {
  return (
      <div style={style.box}>
        <Subheader style={globalStyles.subheader}>Schedule</Subheader>
        { weekArray.map((day, index) => {
          return (

              <div key={index}>
                <Subheader style={{background: '#ebf7eb'}}>{moment(day).format('dddd')}
                  <span style={style.add}>
                  <IconButton onTouchTap={setScheduleFormDate.bind(null, day)}> <AddIcon/> </IconButton>
                </span>
                </Subheader>
                <div style={style.content}>
                  { day.isSame(scheduleDate,'day') && renderForm(operatingHours, onChange, start_time, end_time, submitSchedule)}
                  {renderSchedulesByDay(schedules, day, showAlert)}
                </div>
              </div>)
        })}
      </div>);
};

export default DoctorSchedule;


// WEBPACK FOOTER //
// ./src/screens/profile/doctor/schedule.js